import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import mapSettingsService from "../../services/mapSettingsService";

// Queries
export const useGetMapSettings = (queryOptions = {}) => {
  return useQuery(["mapSettings"], mapSettingsService.index, queryOptions);
};

// Mutations
export const useUpdateMapSettings = (mutationOptions = {}) => {
  const queryClient = useQueryClient();
  return useMutation(mapSettingsService.update, {
    ...mutationOptions,
    onSuccess: (data) => {
      queryClient.setQueryData(["mapSettings"], data);
      mutationOptions.onSuccess(data);
    },
  });
};
